import styled from 'styled-components';

const StyledVideoSlider = styled.div`

width: 70%;
margin: 40px auto;  

.center iframe{
opacity: 0.8;
transform: scale(0.8);
transition: all 0.3s ease-out;
}

.slick-arrow::before {
font-size: 50px;
}

.slick-prev {
left: -55px;
}

@media only screen and (max-width: 500px) {

.slick-arrow::before {
font-size: 30px;
}

.slick-prev {
left: -45px;
}

}

.slick-slide:not(.slick-active) {
pointer-events: none;
}

.slick-slide .slider-item-title{
color: #FFFFFF;
padding: 15px 0;
font-size: 2vw;
white-space:nowrap;

@media only screen and (max-width: 1100px) {
font-size: 3.5vw;
}

}

.slick-slide:not(.slick-active) .slider-item-title{
visibility: hidden;
transition: visibility 0.1s ease-out;
}

.center .slick-center iframe{
opacity: 1;
transform: scale(1);
transition: all 0.3s ease-out;
}

`;

export default StyledVideoSlider;
